import { Page } from '$lib/utils/page';
import { browser } from '$app/environment';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

/** @type {import('./$types').PageLoad} */
export async function load() {
	const metadata = {
		metaTag: [
			{
				content:
					'Manage your ABCmouse account settings, subscription details, and billing information.',
				name: 'description',
			},
			{
				content:
					'Manage your ABCmouse account settings, subscription details, and billing information.',
				property: 'og:description',
			},
			{
				content: 'ABCmouse Parent Section | Account Management',
				property: 'og:title',
			},
			{
				content: 'https://www.abcmouse.com/abc/parent-section/',
				property: 'og:url',
			},
		],
		schemaOrg: {
			graph: {
				webPage: {
					description:
						'Manage your ABCmouse account settings, subscription details, and billing information.',
					id: 'https://www.abcmouse.com/abc/parent-section/#webpage',
					name: 'ABCmouse Parent Section | Account Management',
					url: 'https://www.abcmouse.com/abc/parent-section/',
				},
			},
		},
		title: 'ABCmouse Parent Section | Account Management',
	};

	if (browser) {
		const page = new Page({
			conditions: pageConditions,
			metadata,
			routePath: '/cancel-subscription/pause/manage',
			policies: { policy, policyExceptionHandler },
		});

		return {
			page,
		};
	}
}
